import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Typewriter from 'typewriter-effect';
import { Text } from '../../ui';
import { StyledAnimatedText, StyledAnimatedTextTitleAnimated, } from './AnimatedText.style';
export function AnimatedText({ animatedStrings, secondaryText, gradient, animationDelay, }) {
    const renderTitles = () => {
        return (_jsxs(_Fragment, { children: [_jsx(StyledAnimatedTextTitleAnimated, { gradient: gradient, children: _jsx(Text, { size: "HugeTitleBold", children: _jsx(Typewriter, { onInit: (typewriter) => {
                                animatedStrings.forEach((animatedString) => typewriter
                                    .typeString(animatedString)
                                    .pauseFor(animationDelay || 2000)
                                    .deleteAll()
                                    .start());
                            }, options: { loop: true } }) }) }), !!secondaryText && (_jsx(Text, { children: secondaryText, size: "HugeTitleBold" }))] }));
    };
    return _jsx(StyledAnimatedText, { children: renderTitles() });
}
//# sourceMappingURL=AnimatedText.js.map